import * as React from "react";

const baseProps = {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
};

export function PetIcon01(props) {
    return (
        <svg {...baseProps} {...props}>
            {/* Body */}
            <path d="M63 120C29 98 31 105 34 105C7 75 40 83 14 72L82 56C52 42 114 21 133 32C141 21 134 67 136 89L209 114L227 101C227 89 241 82 251 94C226 130 203 122 199 162L195 143L210 176C192 187 185 201 154 192C162 195 141 175 180 179L159 141L109 139L91 185C78 190 81 184 73 195C58 194 36 198 78 174L92 94L62 111C22 111 19 153 42 129C4 117 41 129 53 113" />
            {/* Ear */}
            <path d="M105 62C112 79 97 63 109 89" />
        </svg>
    );
}

export const petAllowedIcons = [
    PetIcon01,
];
